<div [ngClass]="{ 'group_input': true, 'invalid': ((model.control.dirty || model.control.touched) &&  (invalid | async)), 'input-group': isShowIncrementButtons }">
  <div *ngIf="isShowIncrementButtons" class="input-group-prepend">
    <app-count-button [faIcon]="faMinus" (singleClick)="onClickCountChangeByOne(false)" cssClass="btn btn-lg update-quantity-button"></app-count-button>
  </div>
  <input appTouchKeyboard [readonly]="readonly" [ngClass]="{ 'form-control': isShowIncrementButtons, 'text-center': isTextCenter }" (ngModelChange)="valueChanged($event)" (change)="trimValue($event)" [attr.type]="type" [(ngModel)]="value" [attr.required]="required" [attr.min]="min" [attr.max]="max"/>
  <div *ngIf="isShowIncrementButtons" class="input-group-prepend">
    <app-count-button [faIcon]="faPlus" (singleClick)="onClickCountChangeByOne(true)" cssClass="btn btn-lg update-quantity-button"></app-count-button>
  </div>
  <span class="bar"></span>
  <label><span *ngIf="required">* </span>{{ title }}</label>
</div>
